import { isNil } from 'lodash';
import * as React from 'react';
import { Portal } from 'react-portal';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { usePortalIdStore } from '../../../../../plugins-common/Explanations/store/withPortalId';
import { useExplanationsStore } from '../../../../../plugins-common/Explanations/store/explanations.store';
import { Box } from '../../../../../../Common/BoxV2';
import { useRootElement } from '../../../../../../../slatePlugins/common/hocs/current-element.store';
import { findBellowByType } from '../../../../../../DolEditor/helpers/nodeValue';
import { BLANK_V2 } from '../../../../../plugins-common/BlankV2/types';

const ExplanationEnhanced = ({ element, children }: Partial<RenderElementProps>) => {
  const rootElement = useRootElement();
  const blanks = findBellowByType(rootElement, BLANK_V2);
  const blankOrder =
    blanks.findIndex((blank) => blank.id === element.forId) + (rootElement.startFrom ?? 1);
  return (
    <div>
      Giải thích câu {blankOrder} {children}
    </div>
  );
};

const ExplanationListEnhanced = ({ element, children }: Partial<RenderElementProps>) => {
  return (
    <Grid>
      {children.map((item, index) => (
        <ExplanationEnhanced key={index} children={item} element={element.children[index]} />
      ))}
    </Grid>
  );
};

const ExplanationsElementReadOnlyBase = ({
  children,
  element,
  isEditable,
}: RenderElementProps & { isEditable: boolean }) => {
  const hasNoChildren = isNil(element.children[0]?.forId);
  const store = useExplanationsStore();
  const portalStore = usePortalIdStore();
  const isDoingTest = !isEditable && !store?.isViewResult;
  const hasPortal = portalStore && portalStore.portalId;

  if (!store || isDoingTest) {
    return null;
  }

  return (
    <Box
      boxShadow="unset"
      borderRadius="16px"
      backgroundColor="white100"
      p="0px"
      className="paragraph-toggle-element"
    >
      {store?.isViewResult && hasPortal ? (
        <Portal node={document && document.getElementById(portalStore.portalId)}>
          {!hasNoChildren && <ExplanationListEnhanced element={element} children={children} />}
        </Portal>
      ) : (
        !hasNoChildren && <ExplanationListEnhanced element={element} children={children} />
      )}
    </Box>
  );
};

export const ExplanationsElementReadOnly = observer(ExplanationsElementReadOnlyBase);

const Grid = styled.div`
  display: grid;
  grid-row-gap: 16px;
`;
